import { useTranslation } from "react-i18next";
import PageLayout from "components/layout/PageLayout";
import { useAcceptRequestMutation, useDeclineRequestMutation, useGetAbsenceStatsQuery, useGetPendingAbsenceRequestsQuery, useGetRequestsStatsQuery } from "./api/absenceReportApiSlice";
import AbsenceQuickView from "./components/AbsenceQuickView";
import AbsenceRequestsStats from "./components/AbsenceRequestsStats";
import AbsenceRequestsTable, { KEY_ABSENCEREQUEST_ACTION_ACCEPT, KEY_ABSENCEREQUEST_ACTION_DELETE, KEY_ABSENCEREQUEST_ACTION_DENY } from "./components/AbsenceRequestsTable";
import HasPermission, { CanManageAbsenceRequest } from "app/PermissionChecker";
import AbsencesCalendar from "./components/AbsencesCalendar";
import TopicSubscriber from "app/ws/TopicSubriber";
import { useSelector } from "react-redux";
import { selectCompanyGuid, selectCurrentUserGuid } from "features/auth/authSlice";

const AUTO_REFRESH_INTERVAL = 1000 * 60 * 10 //(10 mins)

const CompanyAbsenceReports = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const canManageAbsenceRequest = HasPermission(CanManageAbsenceRequest)
    const userGuid = useSelector(selectCurrentUserGuid)
    const companyGuid = useSelector(selectCompanyGuid)

    const todayStart = getFirstDateTimeofToday()
    const todayEnd = getLastDateTimeofToday()

    console.log("Today start: " + todayStart)
    console.log("Today end: " + todayEnd)


    const {
        data: absenceReportsUi,
        isSuccess: isAbsentsSuccess,
        isFetching: isAbsentsFetching,
        isError: isAbsentsError,
        error: absentsError,
        refetch: refetchAbsents
    } = useGetAbsenceStatsQuery({ start: (todayStart.getTime() / 1000), end: (todayEnd.getTime() / 1000) })

    const {
        data: pendingRequests,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch: refetchPendingRequests
    } = useGetPendingAbsenceRequestsQuery(null, {
        pollingInterval: AUTO_REFRESH_INTERVAL,
    })

    const {
        data: stats,
        isFetching: isStatsFetching,
        isSuccess: isStatsSuccess,
        isError: isErrorSuccess,
        error: errorStats,
        refetch: refetchStats
    } = useGetRequestsStatsQuery(null, {
        pollingInterval: AUTO_REFRESH_INTERVAL,
    })



    const [acceptRequest, accepetingResult] = useAcceptRequestMutation()
    const [declineRequest, decliningResult] = useDeclineRequestMutation()

    function handlePayload(payload) {
        console.log(JSON.stringify(payload))
    }


    const handleAccept = (id) => {
        console.log('The link was clicked.');
        acceptRequest(id)

    }

    const handleDecline = (id) => {
        console.log('The link was clicked.');
        declineRequest(id)
    }

    const handleRefresh = () => {
        refetchPendingRequests()
        refetchStats()
        refetchAbsents()
    }

    let content;
    if (isSuccess && isStatsSuccess && isAbsentsSuccess) {
        content = (
            <>



                {canManageAbsenceRequest && pendingRequests.length > 0 ? <div className="alert alert-warning alert-dismissible fade show" role="alert">
                    <i className="fa-solid fa-circle-info fa-beat"></i>  {t("absenceReport:helper.pending_request_alert", { count: pendingRequests.length })}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div> : null}

                {
                    canManageAbsenceRequest &&
                    <AbsenceRequestsTable
                        title={t("absenceReport:menu.requests_pending")}
                        icon="fa-solid fa-hourglass-half"
                        items={pendingRequests}
                        onRequestAccepted={handleAccept}
                        onRequestDenied={handleDecline}
                        availableActions={[
                            KEY_ABSENCEREQUEST_ACTION_ACCEPT,
                            KEY_ABSENCEREQUEST_ACTION_DENY,
                            KEY_ABSENCEREQUEST_ACTION_DELETE
                        ]}
                    />

                }

                {/* <AbsenceQuickView
                    data={{
                        today: absenceReportsUi.absences.map(absent =>
                            ({ name: absent.userDisplayName, reason: absent.type, hours: absent.hours })

                        )
                    }}
                /> */}



                <AbsencesCalendar />

                <AbsenceRequestsStats
                    pending={stats.PENDING}
                    accepted={stats.ACCEPTED}
                    denied={stats.DENIED}
                    canceled={stats.CANCELED}
                />



                <TopicSubscriber
                    subTopic={`company/${companyGuid}/user/${userGuid}`}
                    onMessageReceived={handleRefresh}
                />


            </>
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return <PageLayout
        pageTitle={t("absenceReport:menu.absence_dashboard")}
        isLoadingContent={isFetching || isStatsFetching || isAbsentsFetching}
        onPageRefresh={handleRefresh}
        bodyContent={content}
    />


}

export default CompanyAbsenceReports

function getFirstDateTimeofToday() {
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    return date
}

function getLastDateTimeofToday() {
    const date = new Date()
    date.setHours(23, 59, 59, 0)
    return date
}